var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"spread-block-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Контур"}},[_c('polygon',{staticClass:"lc-c-3",attrs:{"points":"210.5 113.23 61.71 113.23 61.71 327.26 210.5 327.26 359.3 327.26 359.3 113.23 210.5 113.23"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }